<template>
  <div style="margin-top: 60px; margin-left: 9%; margin-right: 9%">
    <DashboardTable />
  </div>
</template>

<script setup lang="ts">
import DashboardTable from './components/DashboardTable.vue';
</script>

<style lang="scss" scoped>
.btn-primary {
  background-color: #1045AC;
  border-color: #1045AC;
  border-radius: 4px;
  width: 99px;
}
</style>
